<template>
  <v-dialog v-model="dialogExport" fullscreen hide-overlay persistent transition="dialog-bottom-transition">
    <v-card>
      <v-toolbar dark color="oee-theme">
        <v-btn icon dark @click="closePopup">
          <v-icon>fa-times-circle</v-icon>
        </v-btn>
        <v-spacer></v-spacer>
        <v-toolbar-title> Xuất kho TQ (出口) {{ currentTime | display_date('DD-MM-YYYY') }}</v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <v-layout row wrap pa-3>
          <v-flex lg7 md7 sm7>
            <v-layout row wrap pa-3>
              <v-flex lg12 md12 sm12>
                <v-autocomplete label="Chọn đối tác (承運商)" v-model="selectedPartnerID" :items="partners" item-text="Name"
                  item-value="ID"></v-autocomplete>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-autocomplete v-if="!useBarcodeReader" label="Mã lô (批號)" ref="trancode" :items="bigSuggestListObj"
                  item-text="PackageCode" item-value="PackageCode" v-model="selectedPackageCode"
                  :search-input.sync="search" class="input-group--focused" @change="manualChanged"></v-autocomplete>
                <v-text-field v-else label="Mã lô (批號)" ref="trancode" v-model="selectedPackageCode"
                  class="input-group--focused" @input="codeChanged" @keyup.enter="manualChanged"
                  :disabled="selectedPartnerID == 0"></v-text-field>
              </v-flex>
              <v-flex lg12 md12 sm12 pa-0>
                <v-data-table :headers="headers" :items="BigPackages" :must-sort="true" :mobile-breakpoint="100"
                  disable-pagination hide-default-footer>
                  <template v-slot:item="{ item, index }">
                    <tr>
                      <td>{{ item.PackageCode }}</td>
                      <td class="text-right">{{ item.NumberOfPack | currency }}</td>
                      <td class="text-right">{{ item.TotalSmallPack | currency }}</td>
                      <td class="text-right">{{ item.Weight | currency('', 2) }}</td>
                      <td class="text-right">{{ item.Volume | currency('', 3) }}</td>
                      <td class="text-center">
                        <v-icon small @click="deletePackageCode(index)">fa-trash-alt</v-icon>
                      </td>
                    </tr>
                  </template>
                </v-data-table>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex lg5 md5 sm5 pl-3 pr-2 pt-4>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-layout row wrap pl-5>
                <v-flex lg12 md12 sm12 pa-0>
                  <h-currency-input label="Số lượng (数量)" :value="BigPackages.length" :decimal="0" readonly class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                  <h-currency-input label="Tổng mã (代碼總數)" :value="totalPack" :decimal="0" readonly class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                  <h-currency-input label="Tổng kiện (總包數)" :value="totalSmallPack" :decimal="0" readonly class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                  <h-currency-input label="Tổng cân (總重量)" :value="totalWeight" :decimal="2" readonly class="input-group--focused"></h-currency-input>
                </v-flex>
                <v-flex lg12 md12 sm12 pa-0>
                  <h-currency-input label="Tổng khối (總容積)" :value="totalVolume" :decimal="3" readonly class="input-group--focused"></h-currency-input>
                </v-flex>
              </v-layout>
            </v-form>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1 white--text" @click="saveItem" :disabled="saving">Xuất & In</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import configs from "@/configs";
import _ from "lodash";
import { mapState } from "vuex";
import { getCurrentTime, sendErrorNotice, playSound } from "@/commons/utils";
import { print_export_bigpackage } from '@/commons/hpod';
export default {
  name: "export_popup",
  data() {
    let dataType = configs.DATA_TYPE;
    let configPaging = _.cloneDeep(configs.PAGINATION);
    configPaging.itemsPerPage = 5;
    return {
      selectedPartnerID: 0,
      currentBigExportID: 0,
      addressID: 0,
      valid: true,
      saving: false,
      useBarcodeReader: false,
      exportByBigPackage: false,
      autoPackageCode: configs.SYSTEM_CONFIG.auto_pack_code,
      BIG_PACKAGE_STATUS_ENUM: configs.BIG_PACKAGE_STATUS_ENUM,
      selectedPackageCode: "",
      headers: [
        {
          text: "Mã lô (批號)",
          value: "PackageCode",
          filterable: true,
          quickSearch: true,
          dataType: dataType["String"]
        },
        {
          text: "Tổng mã (代碼總數)",
          value: "NumberOfPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng kiện (總包數)",
          value: "TotalSmallPack",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng cân (總重量)",
          value: "Weight",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Tổng khối (總容積)",
          value: "Volume",
          align: "end",
          filterable: true,
          dataType: dataType["Number"]
        },
        {
          text: "Thao tác",
          value: "",
          align: "center",
          sortable: false,
          filterable: false
        }
      ],
      requireRules: [v => !!v || "Trường dữ liệu không được để trống."],
      PackageCodeRules: [v => (!this.autoPackageCode && !!v) || "Mã lô không được để trống."],
      currentTime: getCurrentTime(),
      BigPackages: [],
      queryTerm: '',
      exportAll: false,

    };
  },
  props: ["dialogExport"],
  watch: {
    useBarcodeReader() {
      if (this.useBarcodeReader) {
        this.$nextTick(() => this.$refs.trancode.focus());
      }
    },
    dialogExport() {
      if (this.dialogExport) {
        this.BigPackages = [];
        this.selectedPartnerID = 0;
      }
    },
    selectedPartnerID() {
      this.getSuggestList();
    },
    exportAll() {
      if (this.exportAll) {
        this.BigPackages = this.bigSuggestList;
      }
      else {
        this.BigPackages = [];
      }
    }
  },
  computed: {
    ...mapState({
      partners: state => state.partner.all.data,
      bigSuggestList: state => state.bigPackage.inTQ,
      currentItem: state => state.bigExport.selected,
      loading: state => state.bigExport.loading
    }),
    search: {
      get() {
        return this.queryTerm
      },
      set(searchInput) {
        if (this.queryTerm !== searchInput) {
          this.queryTerm = searchInput;
        }
      }
    },
    bigSuggestListObj() {
      return _.filter(this.bigSuggestList, (p) => { return !_.find(this.BigPackages, { 'PackageCode': p.PackageCode }) })
    },
    totalPack() {
      return _.sumBy(this.BigPackages, (p) => { return p.NumberOfPack });
    },
    totalSmallPack() {
      return _.sumBy(this.BigPackages, (p) => { return p.TotalSmallPack });
    },
    totalWeight() {
      return _.sumBy(this.BigPackages, (p) => { return p.Weight });
    },
    totalVolume() {
      return _.sumBy(this.BigPackages, (p) => { return p.Volume });
    },
    adminRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Admin) == configs.ROLE_TYPE.Admin;
    },
    paymentRole() {
      return (this.$store.state.authentication.user.roletype & configs.ROLE_TYPE.Payment) == configs.ROLE_TYPE.Payment;
    },
  },
  methods: {
    getSuggestList() {
      this.$store.dispatch("bigPackage/getListInTQ");
      this.BigPackages = [];
    },
    closePopup() {
      this.$emit("closePopup");
    },
    deletePackageCode(index) {
      this.BigPackages.splice(index, 1);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    deleteBigPackage(index) {
      this.BigPackages.splice(index, 1);
      this.$nextTick(() => this.$refs.trancode.focus());
    },
    saveItem() {
      const selectedPartnerName = _.find(this.partners, { ID: this.selectedPartnerID }).Name;
      this.saving = true;
      this.$store.dispatch("bigExport/setDetail", {data: {
        ID: 0,
        PartnerID: this.selectedPartnerID,
        PartnerName: selectedPartnerName,
        TotalPack: this.totalPack,
        TotalSmallPack: this.totalSmallPack,
        TotalWeight: this.totalWeight,
        TotalVolume: this.totalVolume
      }, id: 0 }).then(p => {
        this.$store.dispatch("bigPackage/updateMultiple", {
          BigPackageIDs: _.map(this.BigPackages, "ID"),
          Action: 'exportcn',
          Status: this.BIG_PACKAGE_STATUS_ENUM.DA_CHUYEN,
          BigExportID: p.ID,
          ModifiedBy: this.$store.state.authentication.user.username,
        }).then(() => {
          this.$store.dispatch("bigExport/getDetail", p.ID).then(p => {
            const frame_printing = print_export_bigpackage(p.ID, p.PartnerName, p.TotalPack, p.TotalSmallPack, p.TotalWeight, p.TotalVolume, p.BigPackages);
            var doc = document.getElementById('print_frame').contentWindow.document;
            doc.open();
            doc.write(frame_printing);
            doc.close();
            setTimeout(function () { window.frames["print_frame"].window.print(); }, 1000);
            this.saving = false;
          });
          this.BigPackages = [];
        });
      });
      
    },
    manualChanged() {
      this.$refs.form.validate();
      this.selectedPackageCode = this.selectedPackageCode == '' ? this.queryTerm : this.selectedPackageCode;
      if (this.selectedPackageCode !== "") {
        this.appendPackageCode();
      }
    },
    codeChanged() {
      this.$refs.form.validate();
      if (this.selectedPackageCode !== "" && this.useBarcodeReader) {
        this.appendPackageCode();
      }
    },
    appendPackageCode: _.debounce(
      function () {
        const normalizeCode = (value) => _.toLower(_.trim(_.toString(value)));
        const selectedCode = normalizeCode(this.selectedPackageCode);
        if (!selectedCode) {
          return;
        }
        const checkTran = _.find(this.BigPackages, (p) => { return normalizeCode(p && p.PackageCode) == selectedCode });
        if (checkTran) {
          this.selectedPackageCode = "";
          this.$nextTick(() => this.$refs.trancode.focus());
          sendErrorNotice('Mã lô đã tồn tại trong phiếu.')
          playSound('trung.mp3')
          return;
        }
        const selectedTran = _.find(this.bigSuggestListObj, (p) => { return normalizeCode(p && p.PackageCode) == selectedCode });
        if (selectedTran) {
          this.BigPackages.unshift(selectedTran);
          this.selectedPackageCode = "";
          playSound('co-voice.mp3');
        }
      },
      100,
      {
        leading: false,
        trailing: true
      }
    )
  }
};
</script>